import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import './CompanyAutoComplete.css';
import WarningModal from './WarningModal';

class CompanyAutocomplete extends Component {
  constructor(props) {
    super(props);
    const searchTerm = props.searchTerm || '';
    this.state = {
      searchTerm,
      suggestions: this.filterCompanies(searchTerm),
      showWarning: false,
      warningHoldData: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchTerm !== prevProps.searchTerm) {
      this.setState({ searchTerm: this.props.searchTerm || '' });
    }
  }

  filterCompanies = value => {
    const inputValue = value?.trim().toLowerCase();
    const { companies } = this.props;
    const dropdownList = companies?.filter(company => {
      return company.name
        ? company?.name?.toLowerCase().includes(inputValue)
        : company?.email?.toLowerCase().includes(inputValue);
    });
    return [{ title: 'Companies', suggestions: dropdownList }];
  };

  getCompanyValue = company => company.name || company.email;

  renderSuggestion = company => <div>{company.name || company.email}</div>;

  renderSectionTitle = section => {
    return <strong>{section.title}</strong>;
  };

  getSectionSuggestions = section => {
    return section.suggestions;
  };

  onChange = (event, { newValue }) => {
    if (newValue === '') {
      this.props.onChange({ name: 'company', value: null, suggestion: null });
    }
    this.setState({
      searchTerm: newValue,
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.filterCompanies(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  onCompanySelected = (ev, { suggestion, suggestionValue }, action, success) => {
    const { showWarning } = this.props;
    if (success || !showWarning) {
      const evObj = { name: 'company', value: suggestionValue, suggestion, action };
      this.props.onChange(evObj);
      this.setState({ searchTerm: suggestionValue });
    } else {
      this.setState({
        showWarning: true,
        warningHoldData: { ev, data: { suggestion, suggestionValue } },
        searchTerm: this.props.searchTerm,
      });
    }
  };

  onKeyPress = e => {
    if (!e.currentTarget.value) return;
    if (e.key === 'Enter') {
      const { companies, userAutocomplete } = this.props;
      let suggestion = !userAutocomplete
        ? companies.filter(item => item.name === e.currentTarget.value)
        : companies.filter(item => item.email === e.currentTarget.value);
      this.props.onChange({
        name: 'company',
        value: e.currentTarget.value,
        suggestion: { ...suggestion[0] },
      });
    }
  };

  onWarningClose = () => {
    this.setState({
      showWarning: false,
      warningHoldData: null,
    });
  };

  onWarningActionChange = action => {
    const { warningHoldData } = this.state;
    this.onCompanySelected(warningHoldData.env, warningHoldData.data, action, true);
    this.onWarningClose();
  };

  render() {
    const { searchTerm, suggestions } = this.state;
    const { subText, warningText, showWarning, className } = this.props;
    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: this.props.placeholder || 'Search Company...',
      disabled: this.props.isDisabled || this.props.editStatus,
      value: searchTerm,
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      name: 'company',
      requires: 'true',
      type: 'text',
      className: 'form-control',
    };

    // Finally, render it!
    return (
      <div className={className || 'autocomplete-container'}>
        <Autosuggest
          suggestions={suggestions || []}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getCompanyValue}
          renderSuggestion={this.renderSuggestion}
          multiSection
          renderSectionTitle={this.renderSectionTitle}
          getSectionSuggestions={this.getSectionSuggestions}
          inputProps={inputProps}
          shouldRenderSuggestions={() => true}
          onSuggestionSelected={this.onCompanySelected}
          id="company-autocomplete"
        />

        {subText && <p className="sub-text">{subText}</p>}
        {showWarning && (
          <WarningModal
            onCancel={this.onWarningClose}
            onCustomAction={() => this.onWarningActionChange('transfer')}
            onConfirm={() => this.onWarningActionChange('erase')}
            isOpen={this.state.showWarning}
            onSelectorChange={this.onSelectorChange}
            body={warningText}
            noButtonText="Cancel"
            customButtonText="Transfer"
            yesButtonText="Erase"
          />
        )}
      </div>
    );
  }
}

export default CompanyAutocomplete;
